export class Potential {
  translationKey: string;
  value: string;

  constructor(value: string) {
    this.value = value;
    this.translationKey = 'POTENTIAL.' + value;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/potential.ts